import React from "react";
import { ArrowRight, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="36943" id="hero" className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden border-b border-border bg-background text-foreground" ref={ref}>
      <h1 className="sr-only">About Bodywerks</h1>
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/limassol_clinic_modern_interior.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-[#1A1A2E]/30 backdrop-blur-[1px]" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background/40" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 md:px-6 text-center max-w-4xl">
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <h1 className="text-5xl md:text-7xl lg:text-[4.5rem] font-medium tracking-tight text-[#F8F8F6] leading-[1.1] mb-6 font-serif">
            <span className="text-accent">About</span> Bodywerks
          </h1>

          {}
          <p className="text-xl md:text-[1.25rem] text-[#F8F8F6]/90 mb-10 max-w-2xl mx-auto leading-relaxed font-sans">
            Experience a sanctuary where clinical excellence meets Mediterranean warmth, 
            providing bespoke chiropractic care in the heart of Limassol.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild className="h-12 px-8 text-base font-medium rounded-lg bg-[#3B8FD4] text-white hover:bg-[#3B8FD4]/90 shadow-lg relative overflow-hidden group border-0">
              <Link className="relative z-10 flex items-center gap-2 underline cursor-pointer" href="https://bodywerks.chiroflow.cloud/book" newTab>
                <span>
                  Book an Appointment
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
                {}
                <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent opacity-50 pointer-events-none" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="h-12 px-8 text-base font-medium rounded-lg border-white/30 text-[#F8F8F6] hover:bg-white/10 hover:text-[#F8F8F6] bg-transparent shadow-sm">
              <Link to="/OurStoryPage">
                <span className="flex items-center gap-2">
                  Our Story
                  <Search className="w-4 h-4" />
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}